<template>
    <main-content v-if="current_user.id">

      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item" @click="changeBoard(1)">
          <router-link :class="['nav-link', tab == 'open-banking-requests-list' ? 'active' : '']"
                       to="/open-banking/requests/open-banking-requests-list" data-toggle="tab" role="tab" aria-selected="false" style="cursor:pointer;">
            {{ $t('dashboard.label.open_banking_requests_list') }}
          </router-link>
        </li>
        <li class="nav-item" @click="changeBoard(0)">
          <router-link :class="['nav-link', tab == 'excels-list' ? 'active' : '']"
                       to="/open-banking/requests/excels-list" data-toggle="tab" role="tab" aria-selected="false"
                       style="cursor:pointer;" v-if="$can('export-excel','open-banking')"
          >
            {{ $t('dashboard.label.excel_exports_list') }}
          </router-link>
        </li>
      </ul>

      <div class="tab-content">
        <div v-if="current_user.permissions.length > 0" id="open-banking-requests-list" :class="['tab-pane', tab == 'open-banking-requests-list' ? 'active' : '']">
          <manage-requests v-if="$can('read', 'open-banking')"></manage-requests>
          <common-requests v-else></common-requests>
        </div>

        <div id="excels-list" :class="['tab-pane', tab == 'excels-list' ? 'active' : '']" v-if="$can('export-excel','open-banking')">
          <open-banking-requests-filter-manage v-if="$can('open-banking', 'read')" :action="exportToExcel"
                                        :query="query_filter_excel" :form_id="excel_filter_form_id"></open-banking-requests-filter-manage>
          <open-banking-requests-filter-common v-else :action="exportToExcel"
                                        :query="query_filter_excel" :form_id="excel_filter_form_id"></open-banking-requests-filter-common>
          <div class="fh-datatable bg-white" v-if="status === 'success'">
            <table v-if="excelRequests.data.length > 0" class="table table-light-bordered">
              <thead>
              <tr style="font-size: 0.89rem;">
                <td style="text-align: center; width:70px">#</td>
                <td style="text-align: center">{{ $t('label.from_date') }}</td>
                <td style="text-align: center">{{ $t('label.to_date') }}</td>
                <td>{{ $t('label.status') }}</td>
                <td style="text-align: center">عملیات</td>
              </tr>
              </thead>
              <tbody>
              <tr v-bind:key="index" v-for="(req, index) in excelRequests.data">
                <td style="text-align: center">{{ req.id }}</td>
                <td style="text-align: center">{{ req.from_date }}</td>
                <td style="text-align: center">{{ req.to_date }}</td>
                <td style="text-align: center" class="text-center">
                  <div class="text-white" :class="excelStatusVariant(req.status)">
                    {{ excelStatusStr(req.status) }}
                  </div>
                </td>
                <td class="text-center d-flex justify-content-center align-items-center">
                  <a v-show="req.url" :href="req.url" type="button"
                     style="background: none; border: none; color: #7878e4">
                    <i class="fa fa-download"></i>
                  </a>
                  <button @click="handleReqDelete(req.id)"
                          style="background: none; border: none; color: #c90000">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="excelRequests.data.length > 0" class="pager kt-datatable--paging-loaded">
              <div class="paginationR">
                <button class="btn-link" title="اولی" @click="changePage(1)">
                  &laquo;&laquo;
                </button>
                <button class="btn-link" title="قبلی" @click="changePage(excelRequests.current_page - 1)">
                  &laquo;
                </button>
                <span
                    v-for="(page, index) in ((excelRequests.current_page) - 2, excelRequests.current_page + 2)"
                    :key="index">
                                <button
                                    v-if="(page <= excelRequests.last_page) && page > excelRequests.current_page - 3"
                                    @click="changePage(page)" :id="'page_' + page"
                                    :class="{ 'active': (excelRequests.current_page == index + 1) }">
                                    {{ page }}
                                </button>
                            </span>
                <button class="btn-link" title="بعدی" @click="changePage(excelRequests.current_page + 1)">
                  &raquo;
                </button>
                <button class="btn-link" title="آخری" @click="changePage(excelRequests.last_page)">
                  &raquo;&raquo;
                </button>
              </div>
              <div class="pager-info">
                <select class="mr-3 ml-3 kt-datatable__pager-size" style="width: 60px;" title="اندازه صفحه"
                        @change="changePage(excelRequests.current_page)" id="perpage-value" v-model="per_page">
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                </select>
                <span class="kt-datatable__pager-detail">
                                {{ 'نمایش ' + excelRequests.from + ' - ' + excelRequests.to + ' از ' +
                excelRequests.total }}
                            </span>
              </div>
            </div>
            <div v-else class="text-center p-5 my-3">
              درخواست خروجی اکسل برای شما وجود ندارد!
            </div>
          </div>
          <div class="loader" style="display:none"></div>
        </div>




      </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import ManageRequests from './components/manage-access/open-banking-requests'
import Requests from './components/common-access/open-banking-requests'
import {mapGetters} from "vuex";
import openBankingRequestsFilterManage from "@/views/openBanking/components/manage-access/requests-filter.vue";
import openBankingRequestsFilterCommon from "@/views/openBanking/components/common-access/requests-filter.vue";
import {openBankingService, transactionService} from '@/common/api.service'
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import {KTApp} from "@/plugins/core/app";

export default {
    components: {
      'main-content': mainContent,
      'manage-requests': ManageRequests,
      'common-requests': Requests,
      'open-banking-requests-filter-manage': openBankingRequestsFilterManage,
      'open-banking-requests-filter-common': openBankingRequestsFilterCommon,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            query: {},
            query_filter_excel: {},
            excel_filter_form_id: 'excel',
        }
    },
    computed :{
          ...mapGetters('user', [
              'current_user'
          ]),
        ...mapGetters('openBankingRequests', [
          'status', 'excelRequests'
        ]),
        tab() {
          if (this.$route.params.tab) {
            return this.$route.params.tab;
          }

          return 'open-banking-requests-list';
        },
    },
    methods :{
      handleReqDelete(hashid) {
        transactionService.deleteCoreExcelRequest(hashid)
            .then(response => {
              this.$store.dispatch('openBankingRequests/fetchCoreExcelRequests', this.params).finally(() => {
                localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
              })
              this.toastr.success(response.data.message);
            })
            .catch(({ response }) => {
              this.toastr.error(response.data.message);
            })
      },
      fillParams() {
        this.params = {
          page: this.page,
          perpage: this.per_page,
          type: 'open_banking_requests',
        }
      },
      changePage(pagee) {
        this.page = pagee
        this.fillParams()
        this.$store.dispatch('openBankingRequests/fetchCoreExcelRequests', this.params).finally(() => {
          localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
        })
      },
      excelStatusVariant(status) {
        if (status == "CREATED")
          return "badge badge-secondary"

        if (status == "PROCESSING")
          return "badge badge-warning"

        if (status == "PROCESSED")
          return "badge badge-success"
      },
      excelStatusStr(status) {
        if (status == "CREATED")
          return i18n.t('transaction.excelStatus.created')

        if (status == "PROCESSING")
          return i18n.t('transaction.excelStatus.processing')

        if (status == "PROCESSED")
          return i18n.t('transaction.excelStatus.processed')
      },
      exportToExcel(e, query) {
        query.type = this.params.type;
        let btn = $(e.target);
        let form = $('#open-banking-requests-filter-form' + this.excel_filter_form_id)

        form.validate({
          rules: {
            from_date: {
              required: true,
            },
            to_date: {
              required: true,
            },
          },
        });

        if (!form.valid()) {
          return;
        }

        KTApp.progress(btn)

        this.query_filter_excel = query

        openBankingService.createCoreExcelRequest({
          ...this.query_filter_excel
        }).then(async (response) => {
          await this.$store.dispatch('openBankingRequests/fetchCoreExcelRequests', this.params)
          this.toastr.success(response.data.message)
        }).catch(({ response }) => {
          form.validate().showErrors(response.data.data)
        }).finally(() => {
          KTApp.unprogress(btn)
        });
      },
      changeBoard(board) {
        this.board = board;
      },
    },
    mounted() {
      this.fillParams();
      this.$store.dispatch('openBankingRequests/fetchCoreExcelRequests', this.params).finally(() => {
        localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
      })
    }
}
</script>

<style>
.switch-div {
    width: fit-content;
    padding: 8px 27px;
    background: #fff;
    box-shadow: 0 0 7px 0 #9c9c9c5e;
}

.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #6aad27;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

.slider.round {
    border-radius: 50px;
}

.slider.round:before {
    border-radius: 50px;
}

.info-icon {
    cursor: pointer;
    color: #0f9af0;
    display: inline-block;
}
</style>